var map = {
	"./Colo-Bag-1200x1200.png": 5262,
	"./Fee-Bag-1200x1200.png": 1210,
	"./Feedy-1-1200x1200.png": 3353,
	"./Gastrolene-Plus-1200x1200.png": 9634,
	"./Gastrolene-Pur-1200x1200.png": 4377,
	"./Romolene-1200x1200.png": 6625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 431;